/* eslint-disable react/prop-types */
import { usePortal } from '@/portal/PortalProvider';

/** The card every portal sign-in page sits in, headed by the firm's branding. */
const PortalAuthCard = ({ title, subtitle, children }) => {
  const { branding } = usePortal();

  return (
    <div className="card max-w-[420px] w-full">
      <div className="card-body flex flex-col gap-5 p-10">
        <div className="flex flex-col items-center gap-2 text-center">
          {branding.logo && (
            <img src={branding.logo} alt={branding.firm_name ?? 'logo'} className="h-auto max-h-[70px] w-[175px] object-contain" />
          )}
          <span className="text-sm font-semibold text-gray-700">{branding.firm_name}</span>
          <span className="text-2xs uppercase tracking-wide text-gray-500">Client Portal</span>
        </div>

        <div className="text-center">
          <h3 className="text-lg font-semibold text-gray-900 leading-none mb-2">{title}</h3>
          {subtitle && <p className="text-2sm text-gray-600">{subtitle}</p>}
        </div>

        {children}
      </div>
    </div>
  );
};

export { PortalAuthCard };
